module.exports = __webpack_public_path__ + "img/search-session-temp.76ecb908.png";